import { ForwardedRef, forwardRef } from 'react';

import { getCurrencyList } from '@ingrid/localization';

import { SimpleSearchSelect } from '~src/components/SimpleSearchSelect/SimpleSearchSelect';
import { useTranslation } from '~src/i18n/use-translation';

interface Props {
  onChange: (value: string) => void;
  value: string | undefined;
  invalid?: boolean;
}

function CurrencySelectElement({ value, invalid, onChange }: Props, ref: ForwardedRef<HTMLButtonElement>) {
  const { i18n } = useTranslation();

  return (
    <SimpleSearchSelect
      options={getCurrencyList(i18n.resolvedLanguage!).map(([a]) => [a, a])}
      onValueChange={value => onChange(value[0])}
      value={value ? [value] : undefined}
      invalid={invalid}
      ref={ref}
    />
  );
}

export const CurrencySelect = forwardRef(CurrencySelectElement);
